import React from 'react';
import Skeleton, {SkeletonProps} from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonLoaderProps {
    isLoading: boolean;
    children: React.ReactNode;
    props?: SkeletonProps;
}

function SkeletonLoader({isLoading, children, props}: SkeletonLoaderProps): JSX.Element {
    return <>{isLoading ? <Skeleton containerClassName="c-skeleton-loader" {...props} height="100%" /> : children}</>;
}

export default SkeletonLoader;
